import styles from "./cim-header.module.css";
import { LeftHeader } from "frontend/app-header/left-header/left-header";
import { RightHeader } from "frontend/app-header/right-header/right-header";

export const CimHeader = ({ reps, setFollow }: { reps: any; setFollow: (id: string) => void }) => {
  return (
    <div className={styles.cimHeader}>
      <LeftHeader />
      <RightHeader reps={reps} setFollow={setFollow} />
    </div>
  );
};
